export default __webpack_public_path__ + "static/media/logo_icon_grey.4ff35e18.png";